import { formatDate, once, pickForToday } from '../util';

// Small index generated by scripts/build-feed-index.js
// (the full letters.json is only loaded on the Letters page).
export const loadLettersIndex = once(async () => {
  const res = await fetch('/feed-index/letters.json');
  if (!res.ok) throw new Error(`letters index ${res.status}`);
  return res.json();
});

const letters = {
  id: 'letters',
  label: 'Letters',
  async getItems({ now }) {
    const index = await loadLettersIndex();
    return pickForToday(index, 6, {
      now,
      key: (l) => l.id,
      date: (l) => l.date,
    }).map((l) => ({
      id: `letters:${l.id}`,
      type: 'letter',
      kicker: `Letter · ${formatDate(l.date)}`,
      title: `From ${l.from} to ${l.to}`,
      summary: l.excerpt,
      date: l.date,
      lang: 'en',
      link: `/letters?letter=${encodeURIComponent(l.id)}`,
    }));
  },
};

export default letters;
